var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRfpEditWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1573 2.46875H2.73378C2.13521 2.46875 1.65039 2.98282 1.65039 3.61606V9.35153C1.65039 9.98531 2.13521 10.4988 2.73378 10.4988H8.69243C9.291 10.4988 9.77582 9.98531 9.77582 9.35153V5.15339L7.65562 7.39818C7.47048 7.59617 7.22935 7.73298 6.96442 7.79036L5.51214 8.09805C4.56417 8.29848 3.72888 7.41389 3.91847 6.41067L4.20882 4.87279C4.26136 4.59545 4.39029 4.34031 4.57934 4.14042L6.1573 2.46875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7766 1.46344C10.7218 1.32478 10.6415 1.19763 10.5399 1.08858C10.4399 0.981938 10.3194 0.896625 10.1856 0.837777C10.0538 0.77989 9.91138 0.75 9.76741 0.75C9.62344 0.75 9.48104 0.77989 9.34922 0.837777C9.21542 0.896625 9.09492 0.981938 8.99496 1.08858L8.69919 1.40168L10.2441 3.0376L10.5399 2.72396C10.6426 2.61574 10.723 2.48837 10.7766 2.34911C10.8882 2.06443 10.8882 1.74811 10.7766 1.46344ZM9.47869 3.84852L7.93323 2.21206L5.34555 4.95304C5.30738 4.99371 5.28163 5.04446 5.27134 5.09929L4.98099 6.63771C4.94307 6.83814 5.11046 7.01473 5.29951 6.97464L6.75234 6.6675C6.8052 6.65572 6.85331 6.62836 6.89047 6.58896L9.47869 3.84852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfpEditWhite);
export default __webpack_public_path__ + "static/media/RFPEditWhite.272d4d9ea11721d17015c91669e84a82.svg";
export { ForwardRef as ReactComponent };